// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nuJu3xTwYvkvZsqyBSg5 {
    display: flex;
    gap: 0.8rem;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 1.6rem;
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/pages/Drips/Detail/detail.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;AACzB","sourcesContent":[".versionSwitch {\n    display: flex;\n    gap: 0.8rem;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 1.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var versionSwitch = `nuJu3xTwYvkvZsqyBSg5`;
export default ___CSS_LOADER_EXPORT___;
